<template>
  <m-geo-box geo-option="moreArea" @go="goNext" :need-next="this.step === 'zip'">
    <b-container fluid>
    <b-row class="geoType">
        <b-link v-for = "item in geoOptions" :key="item.name"
                @click="tigger(item.name)"
                class="m-btn-check"
                :class="{active: item.name === step}" style="width: 20%;">
          {{item.desc}}
        </b-link>
    </b-row>
      <b-row>
        <b-col>
          <m-geo-zip v-show="this.step === 'zip'" :geoType="5" :is-go.sync="isGo" :changeGeoType="23"></m-geo-zip>
          <m-geo-select v-show="this.step === 'city'" :geoType="4" :changeGeoType="23"></m-geo-select>
          <m-geo-select v-show="this.step === 'county'" :geoType="3" :changeGeoType="23"></m-geo-select>
          <m-geo-state v-show="this.step === 'state'" :geoType="23" :changeGeoType="23"></m-geo-state>
        </b-col>
      </b-row>
    </b-container>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoSelect from '@/components/geo/MGeoSelect'
  import MGeoState from '@/components/geo/MGeoState'
  import MGeoZip from '@/components/geo/MGeoZip'

  export default {
    components: {
      MGeoBox,
      MGeoSelect,
      MGeoZip,
      MGeoState
    },
    data () {
      return {
        isGo: false,
        step: 'zip',
        geoOptions: [
          {
            name: 'zip',
            desc: 'Zip'
          },
          {
            name: 'city',
            desc: 'City'
          },
          {
            name: 'county',
            desc: 'County'
          },
          {
            name: 'state',
            desc: 'State'
          }
        ]
      }
    },
    methods: {
      tigger (s) {
        this.step = s
      },
      goNext () {
        this.isGo = true
      }
    }
  }
</script>

<style scoped>
  .geoType {
    padding: 1em 0;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-grow: 1;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoMoreArea.vue